import { Box, Chip, Container, Typography } from "@mui/material";
import DateIcon from "../../assets/DateIcon";
import LocationIcon from "../../assets/LocationIcon";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { useLandingPageEvents } from "../../hooks/useEvents";
import OutlinedButton from "../OutlinedButton";
import { useInView } from "react-intersection-observer";
import styles from "./styles";

const stripHtml = (html) =>
  html?.replace(/<[^>]*>/g, " ").replace(/\s+/g, " ").trim() ?? "";

const EventBanner = () => {
  const { data: landingEvent } = useLandingPageEvents();
  const navigate = useNavigate();
  const { ref, inView } = useInView({ triggerOnce: true, threshold: 0.1 });

  if (!landingEvent) return null;

  return (
    <Container maxWidth="lg" ref={ref}>
      <Box sx={{
        ...styles.animatedWrapperBaseSx,
        opacity: inView ? 1 : 0,
        transform: inView ? "none" : "translateY(24px)",
      }}>
        <Box sx={styles.layoutRowSx}>
          {/* Image — full-width background panel, image centered inside */}
          <Box sx={styles.imagePanelSx}>
            {/* X arrows filling the full background — mobile only */}
            <Box sx={styles.xArrowsOverlaySx}>
              <svg
                width="100%"
                height="100%"
                viewBox="0 0 400 300"
                preserveAspectRatio="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <line x1="0" y1="0" x2="400" y2="300" stroke="rgba(255,255,255,0.1)" strokeWidth="1" />
                <line x1="400" y1="0" x2="0" y2="300" stroke="rgba(255,255,255,0.1)" strokeWidth="1" />
              </svg>
            </Box>

            {/* FEATURED sidebar label — mobile only */}
            <Box sx={styles.featuredSidebarSx}>
              <Typography component="span" sx={styles.featuredLabelSx}>
                Featured
              </Typography>
            </Box>

            <Box
              component="img"
              src={landingEvent.imageURL}
              alt={landingEvent.name}
              sx={styles.eventImageSx}
            />
          </Box>

          {/* Details */}
          <Box sx={styles.detailsBoxSx}>
            {/* Desktop: chip above title */}
            <Chip
              label="FEATURED EVENT"
              size="small"
              sx={styles.featuredChipSx}
            />

            {/* Title */}
            <Typography variant="h1" sx={styles.titleSx}>
              {landingEvent.name}
            </Typography>

            <Box sx={styles.dateRowSx}>
              <DateIcon />
              <Typography sx={styles.dateLabelSx} color="#c7c7c7">
                {moment(landingEvent.date).format("MMMM Do, YYYY")}
              </Typography>
            </Box>
            {landingEvent.location && (
              <Box sx={styles.locationRowSx}>
                <LocationIcon />
                <Typography sx={styles.dateLabelSx} color="#c7c7c7">
                  {landingEvent.location}
                </Typography>
              </Box>
            )}

            {landingEvent.genres?.length > 0 && (
              <Box sx={styles.genresRowSx}>
                {landingEvent.genres.map((genre) => (
                  <Chip key={genre} label={genre} variant="filled" color="primary" size="small" />
                ))}
              </Box>
            )}

            {landingEvent.description && (
              <Typography variant="body2" sx={styles.descriptionSx}>
                {stripHtml(landingEvent.description)}
              </Typography>
            )}

            <Box sx={styles.buttonRowSx}>
              <OutlinedButton
                sx={styles.viewDetailsButtonSx}
                onClick={() => navigate(`/event/${landingEvent._id}`)}
              >
                VIEW DETAILS
              </OutlinedButton>
              <OutlinedButton
                sx={styles.viewDetailsButtonSx}
                onClick={() => navigate("/events")}
              >
                ALL EVENTS
              </OutlinedButton>
            </Box>
          </Box>
        </Box>
      </Box>
    </Container>
  );
};

export default EventBanner;
